import styled, { css, keyframes } from 'styled-components';
import { device } from '../breakpoints';
import { playGrey10, playGrey15 } from '../design-tokens';
import { getChannelLayout } from './ChannelLayout.styles';
import { getDefaultLayout } from './DefaultLayout.styles';
import { getHeaderTextLayout } from './HeaderTextLayout.styles';
import { getHeroLayout } from './HeroLayout.styles';
import { getLetterGridLayout } from './LetterGridLayout.styles';
import { PLACEHOLDER_LAYOUT } from './PlaceHolder';

const placeholderOpacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const placeholerFade = keyframes`
  0% {
    background-color: ${playGrey10};
  }

  15% {
    background-color: ${playGrey15};
  }

  30% {
    background-color: ${playGrey10};
  }

  100% {
    background-color: ${playGrey10};
  }
`;

const commonRowStyling = css`
    height: 15px;
    margin-top: 10px;
    background-color: ${playGrey10};
`;

export const StyledRow1 = styled.div`
    animation-duration: 2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: ${placeholerFade};
    padding-bottom: 56.25%;
`;

export const StyledRow2 = styled.div`
    ${commonRowStyling}
    width: 80%;
`;

export const StyledRow3 = styled.div`
    ${commonRowStyling}
    width: 60%;
`;

export const StyledRow4 = styled.div`
    ${commonRowStyling}
    display: none;
`;

const getAnimationDelay = () => {
    for (let i = 0; i < 13; i++) {
        return css`
            &:nth-child(${i} + 1) ${StyledRow1} {
                animation-delay: ${i * 150}ms;
            }
        `;
    }
};

export const StyledPlaceHolderItem = styled.div`
    display: inline-block;
    margin-bottom: 30px;
    width: calc(50% - 2px);
    ${getAnimationDelay()}

    @media ${device.GteXsmall} {
        width: calc(33.3% - 2px);
    }

    @media ${device.GteMedium} {
        width: calc(25% - 2px);
    }
`;

const getLayout = (layout) => {
    switch (layout) {
        case PLACEHOLDER_LAYOUT.DEFAULT:
            return getDefaultLayout();
        case PLACEHOLDER_LAYOUT.COLUMN:
            return css`
                flex-direction: column;
            `;
        case PLACEHOLDER_LAYOUT.HEADER_TEXT:
            return getHeaderTextLayout();
        case PLACEHOLDER_LAYOUT.HERO:
            return getHeroLayout();
        case PLACEHOLDER_LAYOUT.LETTER_GRID:
            return getLetterGridLayout();
        case PLACEHOLDER_LAYOUT.CHANNELS:
            return getChannelLayout();
        default:
            return null;
    }
};

export const StyledPlaceHolder = styled.div`
    display: flex;
    width: 100%;
    overflow: hidden;

    animation-duration: 100ms;
    animation-delay: 1s;
    animation-fill-mode: backwards;
    animation-name: ${placeholderOpacity};

    ${(props) => getLayout(props.layout)}
`;
